"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _icons = require("../../icons");

var _MonthCalendar = _interopRequireDefault(require("./MonthCalendar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DialogContentDesktop = function DialogContentDesktop(_ref) {
  var fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      hoverDate = _ref.hoverDate,
      onSelectDate = _ref.onSelectDate,
      onHoverDate = _ref.onHoverDate,
      startWeekDay = _ref.startWeekDay,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      monthFormat = _ref.monthFormat,
      weekDayFormat = _ref.weekDayFormat,
      isSingle = _ref.isSingle,
      complsOpen = _ref.complsOpen,
      dateChanged = _ref.dateChanged,
      highlightToday = _ref.highlightToday,
      singleCalendar = _ref.singleCalendar,
      selectedInput = _ref.selectedInput;
  var containerRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      translateAmount = _useState2[0],
      setTranslateAmount = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      monthArray = _useState4[0],
      setMonthArray = _useState4[1];

  var _useState5 = (0, _react.useState)((0, _dayjs.default)()),
      _useState6 = _slicedToArray(_useState5, 2),
      focusDate = _useState6[0],
      setFocusDate = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      disableNext = _useState8[0],
      setDisableNext = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      wrapperWidth = _useState10[0],
      setWrapperWidth = _useState10[1];

  (0, _react.useEffect)(function () {
    if (containerRef.current) {
      var style = window.getComputedStyle(containerRef.current);

      var _translateAmount = singleCalendar ? containerRef.current.offsetWidth + parseInt(style.marginLeft) - 8 : containerRef.current.offsetWidth / 2;

      setWrapperWidth(_translateAmount);
    }
  }, [singleCalendar]);
  (0, _react.useEffect)(function () {
    if (selectedInput === 'from') setFocusDate(fromDate || (0, _dayjs.default)());else if (selectedInput === 'to') setFocusDate((toDate === null || toDate === void 0 ? void 0 : toDate.subtract(1, 'month')) || (0, _dayjs.default)());else setFocusDate(fromDate || (0, _dayjs.default)());
  }, [complsOpen, fromDate, toDate, selectedInput]);
  (0, _react.useEffect)(function () {
    if (maxDate && focusDate.isAfter((0, _dayjs.default)(maxDate).subtract(2, 'month'), 'month')) {
      setDisableNext(true);
    } else {
      setDisableNext(false);
    }

    function getArrayMonth(date, singleCalendar) {
      var prevMonth = (0, _dayjs.default)(date).subtract(1, 'month');
      var nextMonth = (0, _dayjs.default)(date).add(1, 'month');
      var futureMonth = (0, _dayjs.default)(date).add(2, 'month');

      if (singleCalendar) {
        return [prevMonth, focusDate, nextMonth];
      } else {
        return [prevMonth, focusDate, nextMonth, futureMonth];
      }
    }

    var arrayMonth = getArrayMonth(focusDate, singleCalendar);
    setMonthArray(arrayMonth);
  }, [focusDate, minDate, maxDate, singleCalendar]);

  function increaseFocusDate(date) {
    if (_dayjs.default.isDayjs(date)) {
      setFocusDate(date);
    } else {
      var nextDate = (0, _dayjs.default)(focusDate).add(1, 'month');
      setFocusDate(nextDate);
    }
  }

  function decreaseFocusDate(date) {
    if (_dayjs.default.isDayjs(date)) {
      setFocusDate(date);
    } else {
      var prevDate = (0, _dayjs.default)(focusDate).subtract(1, 'month');
      setFocusDate(prevDate);
    }
  }

  function increaseCurrentMonth(date) {
    if (disableNext) return;
    setTranslateAmount(-wrapperWidth);
    setTimeout(function () {
      increaseFocusDate(date);
      setTranslateAmount(0);
    }, 200);
  }

  function decreaseCurrentMonth(date) {
    setTranslateAmount(wrapperWidth);
    setTimeout(function () {
      decreaseFocusDate(date);
      setTranslateAmount(0);
    }, 200);
  }

  (0, _react.useEffect)(function () {
    if (dateChanged) {
      if ((0, _dayjs.default)(dateChanged).isBefore(focusDate, 'month', true)) {
        decreaseCurrentMonth(dateChanged);
      }

      if ((0, _dayjs.default)(dateChanged).isAfter(focusDate.add(1, 'month'), 'month', true)) {
        increaseCurrentMonth((0, _dayjs.default)(dateChanged).subtract(1, 'month'));
      }
    }
  }, [dateChanged, decreaseCurrentMonth, focusDate, increaseCurrentMonth]);

  function onBackButtonKeyDown(e) {
    if (e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault();
      decreaseCurrentMonth();
      return false;
    }
  }

  function onNextButtonKeyDown(e) {
    if (e.keyCode === 32 || e.keyCode === 13) {
      e.preventDefault();
      increaseCurrentMonth();
      return false;
    }
  }

  function focusOnCalendar() {
    if (containerRef && containerRef.current) {
      var selectedButton = containerRef.current.querySelector('.day.selected');

      if (!selectedButton) {
        selectedButton = containerRef.current.querySelector('.month-calendar:not(.hidden) .day:not(.disabled)');
      }

      if (selectedButton) {
        selectedButton.focus();
      }
    }
  }

  function onKeyDown(e) {
    var allowKeyCodes = [9, 32, 37, 38, 39, 40];

    if (allowKeyCodes.indexOf(e.keyCode) === -1 || !e.target.getAttribute('data-day-index')) {
      return true;
    }

    e.preventDefault();
    var calendarContainer = e.target.parentElement.parentElement.parentElement.parentElement;
    var dayIndex = parseInt(e.target.getAttribute('data-day-index'));
    var dateValue = parseInt(e.target.getAttribute('data-date-value'));
    var date = (0, _dayjs.default)(dateValue);
    var lastDateOfMonth = date.add(1, 'month').set('date', 0).get('date');
    var nextDayIndex = -1;
    var increaseAmount = 0;

    switch (e.keyCode) {
      case 9:
        {
          var doneButton = calendarContainer.parentElement.parentElement.parentElement.querySelector('.submit-button');

          if (doneButton) {
            doneButton.focus();
            return true;
          }

          break;
        }

      case 32:
        e.target.click();
        break;

      case 37:
        increaseAmount = -1;
        break;

      case 38:
        increaseAmount = -7;
        break;

      case 39:
        increaseAmount = 1;
        break;

      case 40:
        increaseAmount = 7;
        break;

      default:
        break;
    }

    nextDayIndex = dayIndex + increaseAmount;

    if (nextDayIndex > 0 && nextDayIndex <= lastDateOfMonth) {
      var selector = ".day[data-day-index=\"".concat(nextDayIndex, "\"]");
      var dayElement = e.target.parentElement.parentElement.querySelector(selector);

      if (dayElement) {
        dayElement.focus();
      }
    } else {
      var nextDate = date.add(increaseAmount, 'day');

      if (increaseAmount > 0 && Math.ceil(nextDate.diff(focusDate, 'month', true)) > 1) {
        if (maxDate && (0, _dayjs.default)(nextDate).isAfter(maxDate, 'month')) return false;
        increaseCurrentMonth();
      } else if (increaseAmount < 0 && Math.ceil(focusDate.diff(nextDate, 'month', true)) > 0) {
        if (minDate && (0, _dayjs.default)(nextDate).isBefore(minDate, 'month')) return false;
        decreaseCurrentMonth();
      }

      setTimeout(function () {
        var query = ".month-calendar[data-month-index=\"".concat(nextDate.get('month') + 1, "\"] .day[data-day-index=\"").concat(nextDate.get('date'), "\"]");
        var dayElement = calendarContainer.querySelector(query);

        if (dayElement) {
          dayElement.focus();
        }
      }, 200);
    }

    return false;
  }

  function renderMonthCalendars() {
    return monthArray.map(function (date, dateIndex) {
      return /*#__PURE__*/_react.default.createElement(_MonthCalendar.default, {
        key: dateIndex,
        hidden: dateIndex === 0 && translateAmount <= 0,
        isAnimating: dateIndex === 0 && translateAmount > 0,
        month: (0, _dayjs.default)(date).get('month'),
        year: (0, _dayjs.default)(date).get('year'),
        onSelectDate: onSelectDate,
        onHoverDate: onHoverDate,
        fromDate: fromDate,
        toDate: toDate,
        hoverDate: hoverDate,
        startWeekDay: startWeekDay,
        minDate: minDate,
        maxDate: maxDate,
        weekDayFormat: weekDayFormat,
        monthFormat: monthFormat,
        isSingle: isSingle,
        highlightToday: highlightToday,
        singleCalendar: singleCalendar
      });
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('calendar-wrapper', {
      single: singleCalendar
    }),
    ref: containerRef,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('calendar-content', {
      isAnimating: translateAmount !== 0,
      single: singleCalendar
    }),
    style: {
      transform: "translateX(".concat(translateAmount, "px)")
    }
  }, renderMonthCalendars()), /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-flippers"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flipper-button",
    onClick: decreaseCurrentMonth,
    onKeyDown: onBackButtonKeyDown,
    role: "button",
    style: {
      paddingLeft: '10px'
    },
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowBackIos, {
    color: "secondary",
    fontSize: "large"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('flipper-button', {
      disabled: disableNext
    }),
    onClick: increaseCurrentMonth,
    onKeyDown: onNextButtonKeyDown,
    role: "button",
    tabIndex: "0",
    onBlur: focusOnCalendar
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowForwardIos, {
    color: "secondary"
  }))));
};

DialogContentDesktop.propTypes = {
  fromDate: _propTypes.default.instanceOf(Date),
  toDate: _propTypes.default.instanceOf(Date),
  hoverDate: _propTypes.default.instanceOf(Date),
  onSelectDate: _propTypes.default.func,
  onHoverDate: _propTypes.default.func,
  startWeekDay: _propTypes.default.string,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  monthFormat: _propTypes.default.string,
  isSingle: _propTypes.default.bool,
  complsOpen: _propTypes.default.bool,
  dateChanged: _propTypes.default.instanceOf(Date),
  highlightToday: _propTypes.default.bool,
  singleCalendar: _propTypes.default.bool
};
DialogContentDesktop.defaultProps = {
  fromDate: null,
  toDate: null,
  hoverDate: null,
  onSelectDate: function onSelectDate() {},
  onHoverDate: function onHoverDate() {},
  startWeekDay: null,
  minDate: null,
  maxDate: null,
  monthFormat: '',
  isSingle: false,
  complsOpen: false,
  dateChanged: null,
  highlightToday: false
};
var _default = DialogContentDesktop;
exports.default = _default;